import script from "./SchoolSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolSelection.vue?vue&type=script&setup=true&lang=js"

import "./SchoolSelection.vue?vue&type=style&index=0&id=08c425e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08c425e2"]])

export default __exports__